// =============================================================================
// HUB COMMUNICATION - Dashboard (CC-25b — version "grille de widgets")
// =============================================================================
// Le rendu historique est conservé dans _CommunicationDashboardLegacy.jsx
// et exposé en widget unique 'communication_dashboard_complet'.
// =============================================================================
import DashboardGrid from "../../components/dashboard/DashboardGrid";

export default function CommunicationDashboard() {
  return (
    <DashboardGrid hub="communication" title="Dashboard Communication" />
  );
}
